/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

import React from "react";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import AppMenuHeaderItem from "../../../../Basis/Components/AppMenuHeaderItem";
import { CommentEditIcon, InfoIcon, NewsIcon, QuestionIcon, RoadmapIcon, SupportIcon } from "../../../../Basis/FontAwesome";
import AppAboutDialog from "../../../../Basis/Views/AppAboutDialog";
import { translationKeys, useTranslation } from "../../Internationalisierung/i18nSupport";
import KontaktformularDialog from "../../Views/KontaktformularDialog";
import AppHelpModel from "./AppHelpModel";
import "./AppHelp.scss";

export default function AppHelp() {
    const vm = new AppHelpModel();
    const { t } = useTranslation();
    return (
        <>
            <div className="lan-apphelp" onClick={vm.openMenu}>
                <QuestionIcon className="lan-apphelp__icon" />
            </div>

            <Menu
                anchorEl={vm.state.anchorEl}
                anchorOrigin={{ vertical: "top", horizontal: "right" }}
                transformOrigin={{ vertical: "top", horizontal: "right" }}
                open={vm.isMenuOpen}
                onClose={vm.closeMenu}
                keepMounted
            >
                <div>
                    <AppMenuHeaderItem text={t(translationKeys.appHelp.support)} />
                    <MenuItem onClick={vm.fragenUndAntworten}>
                        <ListItemIcon>
                            <QuestionIcon fontSize="small" />
                        </ListItemIcon>
                        <ListItemText primary={t(translationKeys.appHelp.fragenUndAntworten)} />
                    </MenuItem>
                    <MenuItem onClick={vm.oeffneKontaktformular}>
                        <ListItemIcon>
                            <SupportIcon fontSize="small" />
                        </ListItemIcon>
                        <ListItemText primary={t(translationKeys.appHelp.oeffneKontaktformular)} />
                    </MenuItem>
                    <MenuItem onClick={vm.oeffneFeedback}>
                        <ListItemIcon>
                            <CommentEditIcon fontSize="small" />
                        </ListItemIcon>
                        <ListItemText primary={t(translationKeys.appHelp.oeffneVerbesserungsvorschlag)} />
                    </MenuItem>
                    <MenuItem onClick={vm.oeffneRoadmap}>
                        <ListItemIcon>
                            <RoadmapIcon fontSize="small" />
                        </ListItemIcon>
                        <ListItemText primary={t(translationKeys.appHelp.oeffneRoadmap)} />
                    </MenuItem>
                    <AppMenuHeaderItem text={t(translationKeys.appHelp.infos)} />
                    <MenuItem onClick={vm.neuigkeiten}>
                        <ListItemIcon>
                            <NewsIcon fontSize="small" />
                        </ListItemIcon>
                        <ListItemText primary={t(translationKeys.appHelp.neuigkeiten)} />
                    </MenuItem>
                    <MenuItem onClick={vm.ueber}>
                        <ListItemIcon>
                            <InfoIcon fontSize="small" />
                        </ListItemIcon>
                        <ListItemText primary={t(translationKeys.appHelp.ueber)} />
                    </MenuItem>
                </div>
            </Menu>

            <KontaktformularDialog
                isOpen={vm.isKontaktformularDialogOpen}
                onGesendet={vm.onKontaktformularGesendet}
                onAbgebrochen={vm.onKontaktformularAbgebrochen}
            />

            <AppAboutDialog
                isOpen={vm.isAboutDialogOpen}
                onOk={vm.onAboutOk}
            />
        </>
    );
}
